import { useMemo, useRef } from "react";
import { useFrame } from "@react-three/fiber";
import { PointMaterial } from "@react-three/drei";
import * as THREE from "three";

export default function Particles() {
    const pointsRef = useRef();

    const count = 3000;
    const area = 120;     // largeur/profondeur au sol
    const floorY = 0;     // sol
    const maxY = 30;     // hauteur avant respawn

    const { positions,colors, speeds } = useMemo(() => {
        const positions = new Float32Array(count * 3);
        const colors = new Float32Array(count * 3);
        const speeds = new Float32Array(count);

        const palette = [
            new THREE.Color("#ff83c4"),
            new THREE.Color("#33CCFF"),
        ];

        for (let i = 0; i < count; i++) {
            const i3 = i * 3;

            positions[i3 + 0] = THREE.MathUtils.randFloatSpread(area);
            positions[i3 + 1] = floorY + Math.random() * 5;
            positions[i3 + 2] = THREE.MathUtils.randFloatSpread(area);

            speeds[i] = THREE.MathUtils.lerp(5, 25, Math.random());

            const c = palette[(Math.random() * palette.length) | 0];
            colors[i3 + 0] = c.r;
            colors[i3 + 1] = c.g;
            colors[i3 + 2] = c.b;
        }

        return { positions, colors, speeds };
    }, []);

    useFrame((_, delta) => {
        const geom = pointsRef.current?.geometry;
        if (!geom) return;

        const pos = geom.attributes.position.array;

        for (let i = 0; i < count; i++) {
            const i3 = i * 3;

            pos[i3 + 1] += speeds[i] * delta;

            if (pos[i3 + 1] > maxY) {
                pos[i3 + 0] = THREE.MathUtils.randFloatSpread(area);
                pos[i3 + 1] = floorY;
                pos[i3 + 2] = THREE.MathUtils.randFloatSpread(area);
            }
        }

        geom.attributes.position.needsUpdate = true;
    });

    return (
        <points ref={pointsRef} position={[0, -3, 20]}>
            <bufferGeometry>
                <bufferAttribute
                    attach="attributes-position"
                    array={positions}
                    itemSize={3}
                    count={count}
                />
                <bufferAttribute
                    attach="attributes-color"
                    array={colors}
                    itemSize={3}
                    count={count}
                />
            </bufferGeometry>

            <PointMaterial
                transparent
                size={0.1}
                sizeAttenuation
                vertexColors
                // blending={THREE.AdditiveBlending}
            // depthWrite={false}
            // toneMapped={false}
            />
        </points>
    );
}
